import { fmtDate } from "../api";
import { useLang, useT } from "../i18n";
import { Head, useApi, useShell } from "../ui";

interface Referral { id: string; name?: string; city?: string; country?: string; state: string; createdAt: string; convertedAt?: string }

/** The two referral cards (S16): advisors (the $50 bonus) and clients (the attribution link and code). */
export function ReferCards({ compact }: { compact?: boolean }) {
  const t = useT();
  const { me, toast } = useShell();
  const code = me.partner.code ?? "";
  const agentLink = `${location.origin}/join?ref=${encodeURIComponent(code)}`;
  const clientLink = `https://yesgetaways.com/?via=${encodeURIComponent(code)}`;
  const copy = (s: string) => { void navigator.clipboard?.writeText(s); toast("Link copied."); };
  return (
    <div className="ref-two" aria-label="Refer and earn">
      {me.expert ? (
        <section className={`ref ref-a${compact ? " sm" : ""}`}><div><span className="eyebrow">{t("refer.agent")}</span><h3>{t("refer.agentText")}</h3><code data-testid="agent-link" style={{ overflowWrap: "anywhere" }}>{agentLink}</code><div style={{ marginTop: ".6rem" }}><button className="btn ink" type="button" onClick={() => copy(agentLink)}>{t("refer.copy")}</button> <a className="btn line" href={agentLink} target="_blank" rel="noopener">Open</a></div></div></section>
      ) : null}
      <section className={`ref ref-t${compact ? " sm" : ""}`}><div><span className="eyebrow">{t("refer.client")}</span><h3>{t("refer.clientText")}</h3><code style={{ overflowWrap: "anywhere" }}>{clientLink}</code><p className="muted">Code: <b>{code}</b></p><div style={{ marginTop: ".6rem" }}><button className="btn line" type="button" onClick={() => copy(clientLink)}>{t("refer.copy")}</button></div></div></section>
    </div>
  );
}

export function Refer() {
  const t = useT();
  const lang = useLang();
  const { me } = useShell();
  const { data } = useApi<{ referrals: Referral[] }>(me.expert ? "/referrals" : null);
  const list = data?.referrals ?? [];
  return (
    <>
      <Head eyebrow={t("refer.eyebrow")} title={t("refer.title")} />
      <ReferCards />
      {me.expert ? (
        <>
          <section className="ref-kpis"><div><b>${list.filter((r) => r.state === "converted").length * 50}</b><span>earned from advisor referrals</span></div><div><b>{list.length}</b><span>advisors joined with your link</span></div><div><b>{list.filter((r) => r.state === "converted").length}</b><span>made their first sale</span></div></section>
          <section className="card"><div className="card-head"><h3>{t("refer.invited")}</h3></div>
            <div className="tbl-wrap"><table className="bk"><thead><tr><th>Name</th><th>City</th><th>Joined</th><th>Status</th></tr></thead><tbody>{list.length ? list.map((r) => <tr key={r.id}><td>{r.name}</td><td>{r.city ?? ""}{r.country ? `, ${r.country}` : ""}</td><td>{fmtDate(r.createdAt, lang)}</td><td><span className={`pill${r.state === "converted" ? " brass" : ""}`}>{r.state === "converted" ? "$50 earned" : "Signed up"}</span></td></tr>) : <tr><td colSpan={4} className="muted">Nobody yet: share your link.</td></tr>}</tbody></table></div>
          </section>
        </>
      ) : null}
    </>
  );
}
